export default __webpack_public_path__ + "static/media/isla1.52728626.jpg";